import { Platform } from 'react-native';
import * as Application from 'expo-application';

import { BUILD_NUMBER, MARKETING_VERSION } from '@/constants';

export function getAppVersion(): string | null {
  if (Platform.OS === 'web') return MARKETING_VERSION ?? null;
  return Application.nativeApplicationVersion;
}

export function getAppBuildNumber(): string | null {
  if (Platform.OS === 'web') return BUILD_NUMBER?.toString?.() ?? null;
  return Application.nativeBuildVersion;
}
